<template>
    <div class="page_index flex flex_sb">
        <div>
            <div class="page_item flex flex_sb">
                <div class="page_title" :style="titleStyle">{{title}}</div>
                <div class="flex">
                    <div :class="['page_num',title == '违规'? 'page_violations': 'page_rectification']">
                        {{num}}
                    </div>
                    <div class="page_unit">{{unit}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'bigNum',
        props: {
            num: {
                type: [Number, String],
                default: ''
            },
            unit: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: '#CF0A00'
            },
            subColor: {
                type: String,
                default: '#FF4A19'
            }
        },
        data() {
            return {

            }
        },
        components: {

        },
        created() {},
        computed: {
            numStyle() {
                const {
                    color
                } = this
                return `color:${color};`
            },
            titleStyle() {
                const {
                    color
                } = this
                return `color:${color};`
            }
        },
        watch: {},
        methods: {}
    }
</script>

<style lang='scss' scoped>
    .page_index {
        .page_item {
            width: vh(500);
            height: vh(129);
            background-color: #003af2;
            margin-bottom: vh(24);
            padding: 0 vh(20) 0 vh(30);
            border: vh(1) solid #2b5eff;

            .page_num {
                font-size: vh(48);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .page_unit {
                @include font(20, #1A94FF);
                margin: vh(20) 0 0 vh(10);
                font-weight: bold;
            }

            .page_violations {
                background-image: -webkit-linear-gradient(top, #ff4a19, #cf0a00);
            }

            .page_rectification {
                background-image: -webkit-linear-gradient(top, #86ffae, #25df00);
            }

            .page_title {
                @include font(30, #ffffff, center);
                font-weight: bold;
            }
        }
    }
</style>